{
    "ModalTitleAdd": "Ajouter un nouveau rapport",
    "ModalTitleModify": "Modifier le rapport",
    "ModalTitleDateTime": "Plage de dates\/heures",
    "TabnameReport": "Rapport",
    "TabnameFilter": "Filtre",
    "TabnameOther": "Autre",
    "TabnameFields": "Champs",
    "TabnameDashboard": "Mise en page",
    "TabnameSlakpi": "SLA\/KPI",
    "TabnameAlarms": "Alarmes",
    "TabnameScheduling": "Programmation",
    "TabnameAcdCodes": "Codes",
    "TabnameFinancial": "Financier",
    "TabnameSettings": "Paramètres",
    "TabnamePrint": "Imprimer",
    "TabnameAdvanced": "Avancé",
    "ReporttypelabelNolistitems": "Aucun élément de la liste actuelle portant ce nom.",
    "ConfigureReport_ButtonHelpLabel": "De l'aide ?",
    "ConfigureReport_ButtonSubmitLabel": "OK",
    "ConfigureReport_ButtonCancelLabel": "Annuler",
    "ConfigureReport_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
    "ConfigureReport_PromptConfirm": "Oui",
    "ConfigureReport_PromptCancel": "Annuler",
    "ConfigureReport_Basic": "Base",
    "ConfigureReport_Advanced": "Avancé",
    "NAME": "ConfigureReport"
}